module Meevo.Plugins.DrawerManager {
    "use strict";

    export class UnassignedDrawerSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {
        public selectedDrawer: Meevo.Model.Drawer;

        constructor(protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader:boolean,
            personalFooter:boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.UnassignedDrawer, drawerManagerContext, "unassignedDrawer", personalHeader, personalFooter);

        }

        reset() {
            super.reset();
        }

        selectDrawer() {
            // this section is only shown while the Register has no drawer yet, so this picks its starting drawer
            this.context.setSelectedDrawer(this.selectedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
        }

        getSectionName() {
            return "Please select a drawer";
        }
    }

}